<p-table #table [columns]="allColumns" selectionMode="multiple" [value]="tableData" scrollable="true" class="transaction-detail-table liquitics-compact-table"
    scrollHeight="70vh" dataKey="flowKey" [paginator]="true" paginatorPosition="top" [rows]="rowsPerPage" sortMode="multiple" [loading]="loading"
    (onRowSelect)="onTableRowSelect($event)" (onRowUnselect)="onTableRowSelect($event)" [(selection)]="selectedTransactions" styleClass="p-datatable-striped">
    <!--  (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" -->
    <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
            <col *ngFor="let col of columns" [style.width]="col.width">
        </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-template ngFor let-col [ngForOf]="columns">
                <th *ngIf="col.sortable">
                    <span class='transaction-field-header' [pSortableColumn]="col.field">{{col.header}}</span>
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
                <th *ngIf="!col.sortable">
                    <span class='transaction-field-header'>{{col.header}}</span>
                </th>
            </ng-template>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns" [ngClass]="['text-center', rowData.dataClass]" [pEditableColumn]="col.editable">
                <span *ngIf="col.type === 'string'" class='transaction-field'>
                    {{rowData[col.field]}}
                </span>
                <span *ngIf="col.type === 'datetime'" class='transaction-field'>
                    {{rowData[col.field] | moment:'L'}} {{rowData[col.field] | moment:'LTS'}}
                </span>
                <span *ngIf="col.type === 'date'" class='transaction-field'>
                    {{rowData[col.field] | moment:'L'}}
                </span>
                <span *ngIf="col.type === 'amount'" class='transaction-field'>
                    {{rowData[col.field] | currencyrounding:3:rowData.currency:true | negativeparentheses}}
                </span>
                <span *ngIf="col.type === 'icon'" [class]="rowData.iconClass" [matTooltip]="rowData.transactionType"></span>
                <span *ngIf="col.type === 'show'" class="fa fa-file-o" (click)="showTransaction($event, rowData, transactionOverlay)"></span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="summary">
        Selected Total: {{selectedTotal}}
    </ng-template>
</p-table>
<p-overlayPanel #transactionOverlay [showCloseIcon]="true" [appendTo]="table">
    <textarea class="transaction-json">{{fullTransaction}}</textarea>
</p-overlayPanel>